export default __webpack_public_path__ + "static/media/domestic.06a69f2e.jpg";